/* ========================================
   MysteryBites – Interactive Scripts
   ======================================== */

document.addEventListener('DOMContentLoaded', () => {
  // --- Navbar scroll effect ---
  const navbar = document.getElementById('navbar');
  if (navbar) {
    const onScroll = () => {
      navbar.classList.toggle('scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // --- Mobile menu toggle ---
  const mobileToggle = document.getElementById('mobileToggle');
  const navLinks = document.getElementById('navLinks');

  if (mobileToggle && navLinks) {
    mobileToggle.addEventListener('click', () => {
      mobileToggle.classList.toggle('active');
      navLinks.classList.toggle('open');
    });

    // Close mobile menu when a link is clicked
    navLinks.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileToggle.classList.remove('active');
        navLinks.classList.remove('open');
      });
    });
  }

  // --- Scroll-driven animations ---
  const animateElements = document.querySelectorAll(
    '.step-card, .theme-card, .pricing-card, .content-item, .faq-item, .value, .addon-card, .feature-list li'
  );

  animateElements.forEach(el => el.classList.add('animate-in'));

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  animateElements.forEach(el => observer.observe(el));

  // --- Smooth scroll for anchor links ---
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const id = anchor.getAttribute('href');
      if (id === '#') return;
      const target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  // --- Active nav link highlighting ---
  const navIds = ['how-it-works', 'themes', 'pricing', 'about', 'faq'];
  const navSections = navIds.map(id => document.getElementById(id)).filter(Boolean);
  const navAnchors = document.querySelectorAll('.nav-links a');

  const highlightNav = () => {
    const scrollY = window.scrollY + 120;
    navSections.forEach(section => {
      const top = section.offsetTop;
      const height = section.offsetHeight;
      const id = section.getAttribute('id');
      const link = document.querySelector(`.nav-links a[href="#${CSS.escape(id)}"]`);
      if (link) {
        if (scrollY >= top && scrollY < top + height) {
          navAnchors.forEach(a => a.style.color = '');
          link.style.color = 'var(--primary)';
        }
      }
    });
  };

  window.addEventListener('scroll', highlightNav, { passive: true });
});

// --- Cart count badge ---
window.refreshCartCount = function() {
  fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var el = document.getElementById('cart-count');
      if (!el) return;
      if (data.item_count > 0) {
        el.textContent = data.item_count;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
};
